import HandsonTable from "../../../../components/handsonTable/handsonTable";
import { connect } from "react-redux";

export default connect((state) => {
  let {
    tableInfo: { data, colHeaders, colWidths, columns }
  } = state.multiLocationOverview.allLocationsData;
  let columnSorting = Array.isArray(data[0]);

  return {
    data,
    colHeaders,
    height: "65vh",
    width: 1330,
    stretchH: "all",
    columnSorting,
    columns: columnSorting ? columns : null,
    colWidths,
    fragmentSelection: false,
    nestedRows: true,
    rowHeaders: true,
    showExportFileButton: true
  };
})(HandsonTable);
